import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ionPeopleOutline, ionFileTrayOutline } from '@ng-icons/ionicons';
import { provideIcons } from '@ng-icons/core';
import { AreaService } from 'src/app/api/services';
import { JobDatesOptions } from 'src/app/core/constant/job-dates';
import { JobExperienceOptions } from 'src/app/core/constant/job-experience';
import { CommonModule } from '@angular/common';
import { EducationDegreeService } from 'src/app/api/services/education-degree.service';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { InputSelectComponent } from '@components/input-select/input-select.component';

@Component({
  selector: 'app-filter-section',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    InputSelectComponent,
  ],
  templateUrl: './filter-section.component.html',
  viewProviders: [provideIcons({ ionPeopleOutline, ionFileTrayOutline })],
})
export class FilterSectionComponent implements OnInit {
  @Output() filtersChanged = new EventEmitter<any>();
  @Input() loading: boolean = false;

  filtersForm!: FormGroup;
  areas: any[] = [];
  selectedArea: string | null = null;

  modalidades: any[] = [];
  selectedModalidad: string | null = null;

  fechas = JobDatesOptions;
  selectedFecha: string | null = null;
  selectedFechaValue: number | null = null;

  experiencias = JobExperienceOptions;
  selectedExperiencia: string | null = null;

  constructor(
    private areaService: AreaService,
    private educationDegreeService: EducationDegreeService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.filtersForm = this.fb.group({
      idArea: [null],
      idEducation: [null],
      minimumExperience: [null],
    });
    this.filtersForm.valueChanges.subscribe((changes) => {
      this.emitFilters();
    });

    this.areaService.areaGet().subscribe({
      next: (data) => {
        const loadedAreas = data.dto.areas.map((a: any) => ({
          label: a.name,
          value: a.idArea,
        }));
        this.areas = [
          { label: 'Todas las áreas', value: null },
          ...loadedAreas,
        ];
      },
      error: (err) => console.error('Error al obtener áreas:', err),
    });

    this.educationDegreeService.getActiveEducationDegrees().subscribe({
      next: (data) => {
        const loadedModalidades = data.dto.educations.map((a: any) => ({
          label: a.name,
          value: a.idEducation,
        }));

        this.modalidades = [
          { label: 'Todos los niveles', value: null },
          ...loadedModalidades,
        ];
      },
      error: (err) => console.error('Error al obtener modalidades:', err),
    });

    this.experiencias = [
      { label: 'Toda la experiencia', value: null },
      ...JobExperienceOptions,
    ];
  }

  emitFilters() {
    const formValues = this.filtersForm.value;

    const filters: any = {
      idArea: formValues.idArea || null,
      idEducation: formValues.idEducation || null,
      minimumExperience: formValues.minimumExperience || null,

      publicationDate:
        this.selectedFechaValue !== null
          ? this.getPublicationDate(this.selectedFechaValue)
          : null,
    };
    this.filtersChanged.emit(filters);
  }

  onSelectModalidad(value: string | null) {
    this.selectedModalidad = value;
    this.emitFilters();
  }

  onSelectArea(value: string | null) {
    this.selectedArea = value;
    this.emitFilters();
  }

  onSelectExperiencia(value: string | null) {
    this.selectedExperiencia = value;
    this.emitFilters();
  }

  onSelectFecha(value: number | null) {
    this.selectedFechaValue = value;
    this.emitFilters();
  }

  clearFilters() {
    this.filtersForm.reset({
      idArea: null,
      idEducation: null,
      minimumExperience: null,
    });
    this.selectedFechaValue = null;
    this.emitFilters();
  }

  getPublicationDate(selectedValue: number | null): string | null {
    if (selectedValue === null) return null;

    const today = new Date();
    const targetDate = new Date();
    targetDate.setDate(today.getDate() - selectedValue);
    return this.formatDateDDMMYYYY(targetDate);
  }

  formatDateDDMMYYYY(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
}
